// English translation file
// Keys are organized by page/feature to stay easy to find and extend

const en = {
    common: {
        or: "or",
        loading: "Loading...",
        save: "Save",
        cancel: "Cancel",
        confirm: "Confirm",
        back: "Back",
        edit: "Edit",
        delete: "Delete",
        add: "Add",
        search: "Search",
        submit: "Submit",
        yes: "Yes",
        no: "No",
    },

    nav: {
        home: "Home",
        categories: "Categories",
        products: "Products",
        cart: "Cart",
        dashboard: "Dashboard",
        logout: "Logout",
        login: "Login",
    },

    auth: {
        loginTab: "Login",
        registerTab: "Create Account",

        brandMark: "Our Store",
        discountTag: "Sale",
        welcomeBackTitle: "Welcome back",
        welcomeBackDesc: "Sign in to track your orders and access your special offers.",
        joinStoreTitle: "Join the store",
        joinStoreDesc: "Create your account in under a minute and unlock new-member offers.",

        perkDelivery: "Fast delivery to all areas",
        perkOffers: "Exclusive offers for members",
        perkReturns: "Free returns within 14 days",

        nameLabel: "Full Name",
        emailLabel: "Email",
        passwordLabel: "Password",

        loginButton: "Login",
        registerButton: "Create Account",
        continueWithGoogle: "Continue with Google",

        noAccount: "Don't have an account? ",
        createOne: "Create one now",
        haveAccount: "Already have an account? ",
        loginNow: "Log in",

        loggingOut: "Logging out...",
        logoutButton: "Logout",

        googleLoadingTitle: "Signing in with Google",
        googleLoadingDesc: "One moment, redirecting you automatically...",
        googleErrorTitle: "Sign-in failed",
        googleErrorDesc: "Something went wrong while verifying your Google account.",
        backToLogin: "Back to login",
    },

    errors: {
        invalidCredentials: "Incorrect email or password",
        emailTaken: "This email is already registered",
        serverError: "A server error occurred, please try again",
        networkError: "Could not reach the server, check your connection",
        logoutFailed: "Could not log out, please try again",
        notFoundTitle: "Page not found",
        notFoundSubtitle: "Looks like you got a little lost! The page you're looking for doesn't exist or has moved.",
        notFoundCta: "Back to Home",
        forbiddenTitle: "You are not authorized to access this page",
    },

    brand: {
        name: "Our Store",
    },

    dashboardNav: {
        users: "Users",
        addUser: "Add User",
        categories: "Categories",
        addCategories: "Add Categories",
        products: "Products",
        addProducts: "Add Products",
        writer: "Writer",
        orders: "Orders",
    },

    table: {
        action: "Action",
        searchPlaceholder: "Search here",
        rowsPerPage: "Rows per page",
        loading: "Loading...",
        searching: "Searching...",
        you: "you",
    },

    roles: {
        "1995": "Admin",
        "1996": "Writer",
        "1999": "Product Manager",
        "2001": "User",
    },

    usersPage: {
        eyebrow: "Dashboard",
        title: "Users",
        addButton: "Add User",
        columnName: "Name",
        columnEmail: "Email",
        columnRole: "Role",
        columnCreated: "Created",
        columnLastLogin: "Last Login",
    },

    products: {
        addTitle: "Add Product",
        editTitle: "Edit Product",
        categoryLabel: "Category",
        selectCategory: "Select a category",
        titleLabel: "Title",
        titlePlaceholder: "Enter product title",
        descriptionLabel: "Description",
        descriptionPlaceholder: "Enter product description",
        priceLabel: "Price",
        pricePlaceholder: "Enter price",
        discountLabel: "Discount",
        discountPlaceholder: "Enter discount",
        aboutLabel: "About",
        aboutPlaceholder: "Enter additional details",
        stockLabel: "Stock",
        stockPlaceholder: "Enter stock quantity",
        imagesLabel: "Images",
        uploadHere: "Click here to upload images",
        save: "Save",
        deleteImage: "Delete",
        pageTitle: "Products",
        addButton: "Add Product",
        columnTitle: "Title",
        columnImages: "Images",
        columnDescription: "Description",
        columnPrice: "Price",
        columnRating: "Rating",
        columnCreated: "Created",
        columnUpdated: "Updated",
    },

    categories: {
        addTitle: "Add Category",
        editTitle: "Edit Category",
        titleLabel: "Title",
        titlePlaceholder: "Enter category title",
        imageLabel: "Image",
        save: "Save",
        pageTitle: "Categories",
        addButton: "Add Category",
        columnTitle: "Title",
        columnImage: "Image",
        columnCreated: "Created",
        columnUpdated: "Updated",
    },

    usersForm: {
        addTitle: "Add User",
        editTitle: "Edit User",
        nameLabel: "Name",
        namePlaceholder: "Enter name",
        emailLabel: "Email",
        emailPlaceholder: "Enter email",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter password",
        roleLabel: "Role",
        selectRole: "Select role",
        save: "Save",
        submit: "Submit",
    },

    footer: {
        rights: "© 2025 Your Company Name. All rights reserved.",
    },

    storefrontNav: {
        searchPlaceholder: "Search Product",
        allCategories: "All",
        cartTitle: "Cart",
        emptyCart: "Your cart is empty",
        close: "Close",
        checkout: "Checkout",
    },

    search: {
        resultsFor: "Search results for",
        noResults: "No results match your search",
        subtitle: "Try different or more general keywords",
    },

    profile: {
        title: "Profile",
        nameLabel: "Name",
        emailLabel: "Email",
        roleLabel: "Account Type",
        logout: "Logout",
        notLoggedInTitle: "You're not logged in yet",
        notLoggedInSubtitle: "Log in to see your details and track your orders",
        loginCta: "Log In",

        tabInfo: "Personal Info",
        tabCart: "Cart",
        tabWishlist: "Wishlist",
        tabOrders: "My Orders",

        phoneLabel: "Phone",
        joinedLabel: "Joined on",

        emptyCart: "Your cart is currently empty",
        emptyWishlist: "No products in your wishlist",
        noOrders: "No previous orders",
        browseShop: "Browse Shop",

        total: "Total",
        loading: "Loading...",
        viewAllOrders: "View all my orders",
        continueToCheckout: "Continue to checkout",
    },

    hero: {
        slide1Badge: "30% OFF",
        slide1LeftLabel: "For Online Order",
        slide1Eyebrow: "New Collection",
        slide1Title: "Your Style Starts Here",
        slide1Subtitle: "The latest fashion and accessories trends, top quality at prices you'll love",
        slide2Badge: "Limited Deal",
        slide2LeftLabel: "For a Limited Time",
        slide2Eyebrow: "Limited Offer",
        slide2Title: "Up to 50% Off",
        slide2Subtitle: "For a limited time on a selected range of products",
        cta: "Shop Now",
    },

    sections: {
        latestSalesTitle: "Latest Sales Products",
        latestSalesSubtitle: "Best prices for a limited time",
        latestProductsTitle: "Latest Products",
        latestProductsSubtitle: "Newly arrived in store",
        topRelatedTitle: "Top Rated",
        topRelatedSubtitle: "Customer favorite picks",
    },

    product: {
        saleBadge: "Sale",
    },

    singleProduct: {
        home: "Home",
        noImages: "No images to display",
        onlyOneLeft: "Only 1 left in stock",
        addToCart: "Add to Cart",
        addingToCart: "Adding...",
        addedToCart: "Added ✓",
        stockAlert: "Requested quantity exceeds available stock",
        wishlistAdd: "Add to wishlist",
        wishlistRemove: "Remove from wishlist",
        about: "About",
        description: "Description",
    },

    categoriesPage: {
        title: "All Categories",
        subtitle: "Browse products by the category you're interested in",
        noProducts: "No products in this category yet",
    },

    // -------------------- Standalone Orders page --------------------
    orders: {
        pageTitle: "My Orders",
        backToProfile: "Back to profile",
        noOrders: "No previous orders",
        browseShop: "Browse Shop",
        loginRequiredTitle: "Log in to view your orders",
        loginCta: "Log in",
        orderNumber: "Order #{{id}}",
        total: "Total",
        notFound: "Order not found",
        confirmCancel: "Are you sure you want to cancel this order?",
        cancelOrder: "Cancel Order",
        cancelling: "Cancelling...",
        cancelError: "Failed to cancel order",
        // -------------------- Added: shipment tracking --------------------
        trackingTitle: "Shipment Information",
        carrier: "Carrier",
        trackingNumber: "Tracking Number",
        trackShipment: "Track Shipment",
        status: {
            pending: "Pending",
            processing: "Processing",
            shipped: "Shipped",
            delivered: "Delivered",
            cancelled: "Cancelled",
        },
        paymentStatus: {
            paid: "Paid ✓",
            not_required: "Cash on Delivery",
            pending: "Awaiting Payment",
            failed: "Payment Failed",
        },
    },


    // -------------------- Checkout page --------------------
    checkout: {
        pageTitle: "Review Order",
        confirmBtn: "Confirm Order",
        confirming: "Confirming order...",
        total: "Total",
        editCartNote: "To edit quantities or remove an item,",
        backToCart: "go back to your cart",
        backToProduct: "Back to product",
        emptyCart: "Your cart is empty, nothing to confirm",
        browseShop: "Browse Shop",
        productUnavailable: "Product unavailable",
        genericError: "Something went wrong while placing the order, please try again",
        shippingTitle: "Shipping Address",
        phonePlaceholder: "Phone number",
        cityPlaceholder: "City",
        addressPlaceholder: "Full address (district, street, building no...)",
        notesPlaceholder: "Additional notes (optional)",
        missingAddress: "Please complete shipping details (phone, city, address)",
        payCod: "Cash on Delivery",
        payOnline: "Card / Wallet",
        payOnlineSoon: "Coming soon",
        orderCreatedAwaitingPayment: "Order #{{id}} created — complete payment below to confirm it",
        verifyingPayment: "Verifying your payment...",
        paymentSuccess: "Payment successful 🎉",
        paymentFailed: "Payment failed",
        redirecting: "Redirecting to your order...",
    },

    // -------------------- Dashboard: Admin Orders --------------------
    adminOrders: {
        pageTitle: "Manage Orders",
        pageSubtitle: "View all customer orders and update their status",
        searchPlaceholder: "Search by order ID or customer name/email...",
        searchBtn: "Search",
        allStatuses: "All statuses",
        loading: "Loading...",
        noResults: "No matching orders",
        colOrderId: "#",
        colCustomer: "Customer",
        colItemsCount: "Items",
        colTotal: "Total",
        colDate: "Date",
        colStatus: "Status",
        // -------------------- Added: payment column --------------------
        colPayment: "Payment",
        details: "Details",
        hide: "Hide",
        prev: "Previous",
        next: "Next",
        updateError: "Failed to update order status",
        // -------------------- Added: shipping info form --------------------
        trackingTitle: "Shipment Information",
        carrierPlaceholder: "Carrier name (e.g. Aramex)",
        trackingNumberPlaceholder: "Tracking number",
        trackingUrlPlaceholder: "Tracking URL (optional)",
        saveTracking: "Save Shipping Info",
        saving: "Saving...",
        trackingUpdateError: "Failed to save shipping info",
        status: {
            pending: "Pending",
            processing: "Processing",
            shipped: "Shipped",
            delivered: "Delivered",
            cancelled: "Cancelled",
        },
    },


    // -------------------- General --------------------
    currency: "SAR",
};

export default en;
